import React from "react";
import { useNavigate } from "react-router-dom";
export default function PortfolioBanner({
  header,
  contentone,
  contenttwo,
  buttontext,
}) {
  const navigate = useNavigate();
  return (
    <div className="portfoliobanner">
      <h1>{header ?? "Unlock Your Potential with NeuroGen"}</h1>
      <p>
        {contentone ??
          "You are just one step away from you’re next diagnose, research or learning, NeuroGen AI empowers you to reach new heights with speed and accuracy, while making the learning fun for you."}
        <br />
        {contenttwo ?? ""}
      </p>
      <button onClick={() => navigate("/register/email")}>
        {" "}
        {buttontext ?? "Try Now"}
      </button>
    </div>
  );
}
